import { NextPageContext } from 'next'

export const expireCookie = (ctx: NextPageContext, cookieKey: string) => {
  ctx.res?.setHeader('Set-Cookie', `${cookieKey}=deleted; Max-Age=0; path=/`)
}
